import { getColorwayName } from 'utils/formatters';
import { cn } from 'utils/styles';
import CardContent from '../CardContent';
import CardWrapper from '../CardWrapper';
import { CardStyle, TextVariantClassNames, TextVariantProps } from '../types';

const TextVariant = ({ sys, index, total, color, cardStyle, headline, copy, className }: TextVariantProps) => {
  const internalClassNames: TextVariantClassNames = {
    cardWrapper: {
      wrapper: cn('pb-6', { 'flex flex-col gap-6': cardStyle !== CardStyle.None }, className?.cardWrapper?.wrapper),
      header: cn(className?.cardWrapper?.header),
      content: cn('h-full grow-1 flex flex-col gap-6 justify-between', className?.cardWrapper?.content),
    },
    cardContent: {
      wrapper: cn('flex-1', className?.cardContent?.wrapper),
      header: {
        wrapper: cn(className?.cardContent?.header?.wrapper),
        eyebrow: cn(className?.cardContent?.header?.eyebrow),
        headline: cn(className?.cardContent?.header?.headline),
      },
      copy: cn(className?.cardContent?.copy),
    },
  };

  const testFixture = 'card-text';

  return (
    <CardWrapper
      cardStyle={cardStyle}
      index={index}
      total={total}
      color={getColorwayName(color)}
      className={internalClassNames.cardWrapper}
      testId={testFixture}>
      <CardContent
        sys={sys}
        headline={headline}
        copy={copy}
        testId={testFixture}
        className={internalClassNames.cardContent}
      />
    </CardWrapper>
  );
};

export default TextVariant;
